import { render, staticRenderFns } from "./ClientForm2.vue?vue&type=template&id=82923fa0&scoped=true"
import script from "./ClientForm2.ts?vue&type=script&lang=ts&external"
export * from "./ClientForm2.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82923fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82923fa0')) {
      api.createRecord('82923fa0', component.options)
    } else {
      api.reload('82923fa0', component.options)
    }
    module.hot.accept("./ClientForm2.vue?vue&type=template&id=82923fa0&scoped=true", function () {
      api.rerender('82923fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/components/P38/ClientForm2/ClientForm2.vue"
export default component.exports